// extracted by mini-css-extract-plugin
module.exports = {"alineacion":"styles_alineacion__2HW-7"};